module.exports = __webpack_public_path__ + "img/ban5.8facf135.jpg";